import { SettingService } from "src/app/system-common/services/setting.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HierarchyServiceHandler } from "./hierarchy.service.handler";


@Injectable({
  
    providedIn: 'root',
  
})

export class HierarchyService extends HierarchyServiceHandler {
    // getOutputPreferences(ref_id: any) {
    //   throw new Error('Method not implemented.');
    // }
    constructor(http: HttpClient, settingService: SettingService) {
      super(http, settingService);
    }
}
